module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0127.jpg?v=03ed285a";